import { DocumentationErrorType, DocumentationIssue, DocumentationIssueType } from '../../../../enums';

export interface IDocumentationSubtypeInt {
    issueType: DocumentationIssueType;
    documentationIssue: DocumentationIssue;
    documentationIssueOtherInfo?: string;
    containedSpecialInstructions: boolean;
    documentationError: DocumentationErrorType;
    documentationErrorOtherInfo?: string;
}
